<template>
  <router-view />
</template>

<script>
import { isHL, getPlatformTitle, getParams } from './common/utils';
export default {
  created() {
    const favicon = document.createElement('link')
    favicon.rel = 'icon'
    if (isHL()) {
      favicon.href = `${location.origin}/favicon_hl.png`
    } else {
      favicon.href = `${location.origin}/favicon_qm.ico`
    }
    const params = getParams(location.href);
    if(params && params.token){
      this.$ls.set("TOKEN", params.token);
    }
    document.title = getPlatformTitle();
    document.head.appendChild(favicon)
  }
}
</script>

